import { Plus, RefreshCw } from '@good/icons';
import { ActionIcon, Button, Group, Paper, Divider, Tooltip } from '@good/ui/core';
import { TimezoneSelector } from 'common-components/timezone';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores/rematch/root-store';
import { usePortalUser } from 'utilities/react-hooks/use-portal-user';
import { useBookings } from '../books-view-context/bookings-view-context';
import { PageHeader } from '@good/ui/templates';
import { useTranslation } from 'react-i18next';

interface BookingsViewToolbarHeaderProps {
  openCreateBooking: () => void;
  openCreateActivityRecord: () => void;
}

export const BookingsViewToolbarHeader = ({
  openCreateBooking,
  openCreateActivityRecord,
}: BookingsViewToolbarHeaderProps) => {
  const { t } = useTranslation('', { keyPrefix: 'bookings' });
  const view = useBookings((selector) => selector.view);
  const onChangeTimezone = useBookings((selector) => selector.onChangeTimezone);
  const refreshListings = useBookings((selector) => selector.refreshListings);
  const bookingDisplayTzMode = useSelector((state: IRootState) => state.bookingsStore.bookingDisplayTzMode);
  const portalUser = usePortalUser();
  const bookingDisplayTzCustom = useSelector((state: IRootState) => state.bookingsStore.bookingDisplayTzCustom);

  return (
    <>
      <PageHeader
        title={t('title')}
        subtitle={t('subtitle')}
        actions={
          <Group justify='end'>
            <Group gap='xs'>
              <Tooltip label='Refresh this view'>
                <ActionIcon onClick={refreshListings} variant='default' size='input-md'>
                  <RefreshCw />
                </ActionIcon>
              </Tooltip>
              {view === 'list' && (
                <Paper withBorder p='xs'>
                  <TimezoneSelector
                    mode={bookingDisplayTzMode}
                    bordered={false}
                    userTimezone={portalUser?.timezone}
                    customTimezone={bookingDisplayTzCustom}
                    onChange={onChangeTimezone}
                  />
                </Paper>
              )}
            </Group>
            {view === 'list' && <Divider orientation='vertical' my={4} />}
            <Button.Group>
              <Button onClick={openCreateBooking} leftSection={<Plus />} size='md'>
                Create booking
              </Button>
              <Button onClick={openCreateActivityRecord} variant='light' size='md'>
                Create activity record
              </Button>
            </Button.Group>
          </Group>
        }
      />
    </>
  );
};
